import { Auth } from "../../models/entities/auth.model";
import isEmpty from "../../utils/isempty.utils";
import http from "../http-common";

const login = (data: Auth) => {
  return http.post<any>("/auth/authenticate", data);
};

const logout = () => {
  if(!isEmpty(sessionStorage.getItem("token")) && !isEmpty(sessionStorage.getItem("refresh_token"))){
    http.get<any>(`/auth/logout`,{headers:{"Authorization": 'Bearer ' + sessionStorage.getItem("token")}})
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("refresh_token");
  }
};

/*const authenticate = (token: string) => {
  return http.get("/actual", { headers: { Authorization: "Bearer " + token } });
};
const refershToken = (token: string) => {
  return http.get("/refresh", { headers: { Authorization: "Bearer " + token } });
};*/

const getUserConnected = () => {
  if (isEmpty(sessionStorage.getItem("token"))) {
    return "";
  } else {
    return sessionStorage.getItem("token");
  }
};


const AuthService = {
  login,
  logout,
  getUserConnected,
};

export default AuthService;
